import Script from 'next/script';
import { prepareHtml } from '@packages/shared/core/common/utils/prepareHtml';
import { CustomAppEvents } from '@packages/shared/core/common/entities';

type OneTrustScriptsProps = {
  oneTrustKey: string;
};

export function OneTrustScripts({ oneTrustKey }: OneTrustScriptsProps) {
  if (!oneTrustKey) {
    return null;
  }

  return (
    <>
      <Script
        key="one-trust-cookie-consent"
        id="one-trust-cookie-consent"
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        data-domain-script={oneTrustKey}
      />

      <Script
        key="one-trust-cookie-consent-init"
        id="one-trust-cookie-consent-init"
        type="text/javascript"
        dangerouslySetInnerHTML={prepareHtml(`function OptanonWrapper() {
          const event = new Event('${CustomAppEvents.ONE_TRUST_LOADED}');
          document.dispatchEvent(event);
        }`)}
      />
    </>
  );
}
